export const min_to_ms = min => min * 60 * 1000;
export const ms_to_s = ms => ms / 1000;

/**
 * A span of time at the two largest units that matter — "45m", "3h 20m", "2d 4h". Under a minute is
 * "<1m", so a near-instant reply still reads as one rather than as "0m".
 */
export const formatDuration = ms => {
	if (ms == null || isNaN(ms)) return '-';
	const minutes = Math.floor(Math.max(ms, 0) / 60000);
	if (minutes < 1) return '<1m';
	const days = Math.floor(minutes / 1440);
	const hours = Math.floor((minutes % 1440) / 60);
	const mins = minutes % 60;
	if (days > 0) return hours > 0 ? `${days}d ${hours}h` : `${days}d`;
	if (hours > 0) return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`;
	return `${mins}m`;
};
